import { useState } from "react";

import FormCard from "@/containers/Auth/FormCard";
import PublicLayout from "@/containers/PublicLayout";
import { ROUTES } from "@/routes_new";
import { cx } from "@/utils";
import AllEarsTitle from "@components/AllEarsTitle";
import Button from "@components/Button";
import Wizard from "@components/Wizard";

import SignupForm from "./partials/SignupForm";
import ActivationSent from "./partials/steps/ActivationSent";
import OrganizationInfo from "./partials/steps/OrganizationInfo";
import PersonalInfo from "./partials/steps/PersonalInfo";

import styles from "./SignupView.module.css";

const STEPS = [PersonalInfo, OrganizationInfo, ActivationSent];

const SignupView = () => {
  const [animated, setAnimated] = useState(0);

  return (
    <PublicLayout
      className={cx(styles.root, {
        [styles.stepOne]: animated === 1,
        [styles.stepTwo]: animated === 2,
      })}
      menu={<Button href={ROUTES.APP_HOME}>{L.PUBLIC_LOGIN_BUTTON}</Button>}
    >
      <AllEarsTitle title={L.SIGN_UP_TITLE} />
      <div className={styles.card}>
        <FormCard>
          <Wizard
            onStepChange={(num) => setAnimated(num)}
            steps={STEPS}
            render={(children) => <SignupForm>{children}</SignupForm>}
          />
        </FormCard>
      </div>
    </PublicLayout>
  );
};
export default SignupView;
